const CENTS_PER_UNIT = 100;
const PRICE_DECIMALS = 2;
const DEFAULT_CURRENCY = "UYU";

const CURRENCY_SYMBOLS: Record<string, string> = {
  ARS: "$",
  USD: "US$",
  EUR: "€",
  BRL: "R$",
  CLP: "$",
  COP: "$",
  MXN: "$",
  PEN: "S/",
  UYU: "$",
  GBP: "£",
};

export function formatPrice(cents: number, currency?: string | null): string {
  const code = currency ?? DEFAULT_CURRENCY;
  const symbol = CURRENCY_SYMBOLS[code] ?? code;
  const decimals = code === "UYU" ? 0 : PRICE_DECIMALS;
  const value = (cents / CENTS_PER_UNIT).toFixed(decimals);
  return `${symbol}${value}`;
}
